
import Vue from "vue";
import Hit from "./Hit.vue";
import { ITemplateFilter } from "../store/state";
interface HitListProps {}

export default Vue.extend<{}, {}, {}, HitListProps>({
  name: "HitList",
  props: {},
  computed: {
    hits() {
      return this.$store.getters.hits;
    },
    showingHits() {
      let currentPage = this.$store.getters.currentPage;
      let count = this.$store.getters.count;
      let allHits = this.$store.getters.hits;
      let filters = this.$store.getters.templateFilter;
      let selectedFilters = filters.filter(
        (filter: ITemplateFilter) => filter.selected
      );

      let showingHits =
        selectedFilters.length > 0
          ? Object.keys(allHits)
              .filter((key) => {
                let filterMatching = false;
                selectedFilters.forEach((filter: ITemplateFilter) => {
                  if (filter.name === key) {
                    filterMatching = true;
                  }
                });
                return filterMatching;
              })
              .reduce((cur, key) => {
                return Object.assign(cur, { [key]: allHits[key] });
              }, {})
          : allHits;
      let correctAmountOfHits: { [k: string]: any } = {};
      let amountAdded = 0;

      Object.keys(showingHits).forEach((key: string) => {
        showingHits[key].forEach((hit: any) => {
          if (amountAdded < count * (currentPage + 1)) {
            if (key in correctAmountOfHits) {
              correctAmountOfHits[key].push(hit);
            } else {
              correctAmountOfHits[key] = [hit];
            }
            amountAdded++;
          }
        });
      });
      let amountOfShowingHits = 0;
      Object.keys(correctAmountOfHits).forEach((key) => {
        amountOfShowingHits += correctAmountOfHits[key].length;
      });
      this.$store.commit({
        type: "setCurrentlyShowingHits",
        payload: showingHits,
      });
      this.$store.commit({
        type: "setAmountOfShowingHits",
        payload: amountOfShowingHits,
      });
      return correctAmountOfHits;
    },
  },
  components: {
    Hit,
  },
  updated() {
    if (this.$store.getters.shouldFocus) {
      const hitsref = this.$refs.hit as Array<any>;
      const listElementToFocus = hitsref[this.$store.getters.focusIndex].$el;
      if (listElementToFocus) {
        const anchor = listElementToFocus.getElementsByTagName("a")[0];
        anchor.focus();
        const y =
          listElementToFocus.getBoundingClientRect().top +
          window.pageYOffset -
          85;
        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
      this.$store.commit({
        type: "shouldFocus",
        payload: {
          shouldFocus: false,
          index: 0,
        },
      });
    }
  },
});
